<template>
  <global-loader v-if="show" />
</template>

<script>
import EventBus, { EVENTS } from "@/lib/event-bus"

import GlobalLoader from "@/components/GlobalLoader"

export default {
  components: {
    GlobalLoader
  },

  data() {
    return {
      show: false
    }
  },

  mounted() {
    EventBus.$on(EVENTS.SHOW_GLOBAL_LOADER, () => (this.show = true))
    EventBus.$on(EVENTS.HIDE_GLOBAL_LOADER, () => (this.show = false))
  }
}
</script>
